<template>
  <div class="closingEfficiency">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>办结效率
      </span>
      <!-- <span class="other more">更多</span> -->
    </div>
    <div class="closingEfficiency-main">
      <el-scrollbar style="height:100%;">
        <el-table
          :data="tableData"
          stripe
          height="100%"
          :header-cell-style="{background:'#eff6ff',color:'#333333'}"
        >
          <el-table-column prop="ProjectType" align="center" width="250" label="业务类型"></el-table-column>
          <el-table-column prop="ProjectNum" align="right" label="业务总数"></el-table-column>
          <el-table-column prop="OverNum" align="right" label="已完成"></el-table-column>
          <el-table-column prop="NoOverNum" align="right" label="未完成"></el-table-column>
          <!-- <el-table-column prop="LateNum" align="right" label="超期业务(件)"></el-table-column> -->
          <el-table-column prop="OverNumRate" align="right" label="完结率">
            <template slot-scope="scope">
              <div>{{scope.row.OverNumRate}}%</div>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import { HomePageExControllerSvr } from '@/service/HomePageExControllerSvr';
import { mapState } from 'vuex';

export default {
  components: {},
  props: {},
  data() {
    return {
      Position: 'running',
      tableData: []
    };
  },
  computed: {
    mainTitle: () => {
      return commonTitle;
    },
    ...mapState(['token'])
  },
  created() {
    this.HomePageExControllerSvr = new HomePageExControllerSvr();
  },
  methods: {
    getEfficiencyList() {
      this.HomePageExControllerSvr.GetEfficiencyList(this.token).then(
        res => {
          this.tableData = res;
        },
        err => {
          this.$message({
            message: err,
            type: 'error'
          });
        }
      );
    }
  },
  mounted() {
    this.getEfficiencyList();
  }
};
</script>
<style lang="scss" scoped>
@import '../css/common.scss';
.closingEfficiency {
  background-color: #fff;
  .closingEfficiency-main {
    text-align: center;
    height: 260px;
    .el-scrollbar__view {
      position: relative;
      .el-table {
        // padding: 0 20px 20px 20px;
        padding: 0 5px 5px 5px;
        position: absolute;
        // width: auto;
        max-width: none;
      }
      .el-table::before {
        display: none;
      }
      .el-radio-group {
        margin-top: 15px;
        margin-bottom: 0 !important;
        .el-radio-button {
          .el-radio-button__inner {
            padding: 6px 20px;
          }
        }
      }
    }
  }
}
</style>